import type { Paginated, Subject } from '../domain/entities/content.entity';

/** O teto de `perPage` do back (`PaginationQueryDto`, `@Max(1000)`). */
export const SUBJECTS_PAGE_SIZE = 1000;
/** Guarda contra laço: 50 páginas de 1000 é 50× o acervo de hoje. */
export const MAX_SUBJECT_PAGES = 50;

/**
 * Busca o acervo inteiro de assuntos, página a página. O Mapa de assuntos
 * precisa do conjunto todo: antes pedia só `page: 1, perPage: 1000` e o que
 * passava disso sumia sem aviso.
 *
 * Para quando acumulou o último `total` lido, quando uma página volta vazia (o
 * `total` encolheu durante a carga) ou no teto de páginas. Uma página que falha
 * rejeita tudo: o mapa nunca se desenha pela metade.
 */
export async function fetchAllSubjects(
  listPage: (page: number, perPage: number) => Promise<Paginated<Subject>>,
): Promise<{ items: Subject[]; total: number }> {
  const items: Subject[] = [];
  let total = 0;
  for (let page = 1; page <= MAX_SUBJECT_PAGES; page++) {
    const result = await listPage(page, SUBJECTS_PAGE_SIZE);
    total = result.total;
    items.push(...result.items);
    if (result.items.length === 0 || items.length >= total) break;
  }
  return { items, total };
}
